/**
 * The public site's identity for search engines and answer engines. Every public
 * page's canonical URL, sitemap entry, structured data, and llms.txt link uses
 * this origin, whatever host served the request.
 */
export const SITE_NAME = 'cubic';
export const SITE_ORIGIN = 'https://www.cubic.dev';

/** Absolute URL on the canonical origin. `path` starts with '/'. */
export function absoluteUrl(path: string): string {
  return `${SITE_ORIGIN}${path}`;
}

/**
 * schema.org publisher/author for every public page. The `@id` ties each page's publisher to
 * the one Organization the homepage describes in full.
 */
export const SITE_PUBLISHER = {
  '@type': 'Organization',
  '@id': `${SITE_ORIGIN}/#organization`,
  'name': SITE_NAME,
  'url': SITE_ORIGIN,
  'logo': absoluteUrl('/apple-touch-icon.png'),
} as const;
